// RustFS は ETag をヘッダーではなく、201 応答の XML 本文に返す。
export const uploadS3Post = ({ signature, body, size, onProgress, onComplete, signal }) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    const abort = () => { xhr.abort() }
    const cleanup = () => { if (signal) signal.removeEventListener('abort', abort) }
    const fail = (error) => {
      cleanup()
      reject(error)
    }
    if (signal?.aborted) {
      reject(new DOMException('Upload aborted', 'AbortError'))
      return
    }
    xhr.open('POST', signature.url, true)
    xhr.timeout = (signature.expires ?? 300) * 1000
    for (const [key, value] of Object.entries(signature.headers ?? {})) {
      xhr.setRequestHeader(key, value)
    }
    xhr.upload.addEventListener('progress', onProgress)
    xhr.addEventListener('abort', () => { fail(new DOMException('Upload aborted', 'AbortError')) })
    xhr.addEventListener('error', () => { fail(new Error('S3 upload failed')) })
    xhr.addEventListener('timeout', () => { fail(new Error('S3 upload timed out')) })
    xhr.addEventListener('load', () => {
      cleanup()
      if (xhr.status < 200 || xhr.status >= 300) {
        reject(Object.assign(new Error(`S3 upload failed: ${xhr.status}`), { source: xhr }))
        return
      }
      const xml = new DOMParser().parseFromString(xhr.responseText, 'application/xml')
      const etag = xhr.getResponseHeader('ETag') || xml.querySelector('PostResponse > ETag')?.textContent
      const location = xhr.getResponseHeader('Location') || xml.querySelector('PostResponse > Location')?.textContent
      if (!etag) {
        reject(new Error('S3 upload response has no ETag'))
        return
      }
      if (onProgress) onProgress({ loaded: size, lengthComputable: true })
      if (onComplete) onComplete(etag)
      resolve({ ETag: etag, ...(location ? { location: new URL(location, signature.url).href } : {}) })
    })
    if (signal) signal.addEventListener('abort', abort)
    xhr.send(body)
  })
}
